const SHOW_LOADING = 'SHOW_LOADING'
const LoadingReducer = (state, { type, visible }) => {
  const currentState = state || false
  if (type === SHOW_LOADING) {
    return visible
  }
  return currentState
}

export default LoadingReducer
